import { addToGlobalThisRet } from "@plugins";

function handleLogoAttacher() {
    const addLogoAttacher = document.querySelector(".js-add-logo-attach-disappearance");

    if (addLogoAttacher) {
        const input = addLogoAttacher.querySelector(".js-file-input");

        input.addEventListener("change", () => {
            if (addLogoAttacher.classList.contains("add-logo__attach--hidden")) {
                addLogoAttacher.classList.remove("add-logo__attach--hidden");
            } else {
                addLogoAttacher.classList.add("add-logo__attach--hidden");
            }
        });
    }
}

addToGlobalThisRet(handleLogoAttacher, "handleAttacher");
